import { Div, Icon, Label, useWindowSize } from "@grassrootly/rn-core";
import moment from "moment";
import { Image, Platform } from "react-native";
import { images } from "../../layout/assets";
import { IPlayerGroup } from "@grassrootly/api";
import { DrawerNavigationProp } from "@react-navigation/drawer";
import { MainStackParamList } from "../../navigation/Navigation.types";
import React from "react";

export default function GroupHeader({
  group,
  navigation,
  renderSubHeader,
}: {
  group: IPlayerGroup;
  navigation: DrawerNavigationProp<MainStackParamList, any, undefined>;
  renderSubHeader?: () => React.ReactNode;
}) {
  const { width } = useWindowSize();
  return (
    <Div classNames={["w100", ...(Platform.OS == "web" ? ["fixed", "w100abs", "zIndex1000"] : [])]}>
      <Div
        classNames={[
          "alignItemsCenter",
          "justifyContentSpaceBetween",
          "relative",
          "ph8",
          renderSubHeader ? "pt-{8}" : "pv8",
          "bgSecondaryMain",
        ]}
      >
        <Div classNames={["maxW-{920}", ...(width > 1200 ? ["w100", "pl-{16}"] : [])]}>
          <Div classNames={["flexColumn"]}>
            <Div classNames={["flexRow", "mv-{8}", "alignItemsCenter"]}>
              <Image
                source={group?.group_logo ? { uri: group.group_logo } : images.groupAvatar}
                style={{ width: 30, height: 30, borderRadius: 30 }}
              />
              <Div classNames={["ml-{8}"]}>
                <Label>{group?.name}</Label>
                <Label type="l4Regular" classNames={["colorNeutralLighterDark"]}>
                  Active since {moment(group?.created_at).format("DD.MM.YYYY")}
                </Label>
              </Div>
            </Div>
            {group && renderSubHeader ? renderSubHeader() : null}
          </Div>
        </Div>
        <Div classNames={["absolute", "top-{8}", "left-{8}"]}>
          <Icon
            classNames={["mb-{auto}", "mt-{8}"]}
            name="arrow_back"
            size={24}
            onPress={navigation.canGoBack() ? navigation.goBack : navigation.toggleDrawer}
          />
        </Div>
      </Div>
    </Div>
  );
}
